import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav/sidenav.component';
import { HeaderComponent } from './header.component';
import { MessageUsDialogComponent } from 'src/app/modules/main/pages/contact/message-us-dialog/message-us-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SidenavComponent, HeaderComponent, MessageUsDialogComponent
    ],
    exports: [SidenavComponent, HeaderComponent]
})
export class HeaderModule { }
